import { copy } from './copy';
import { typography } from './constants/typography';
import { zopaTheme } from '@zopauk/react-components';
import type { AppTheme as CoreAppTheme } from '@zopauk/react-components/types/components/styles/Theme';

interface AppTheme extends CoreAppTheme {
  copy: typeof copy;
}

const themeZopa: AppTheme = {
  ...zopaTheme,
  typography: { ...zopaTheme.typography, ...typography },
  copy,
} as const;

export default themeZopa;
